import { IconButton, TableCell, TableRow, Tooltip } from '@mui/material';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import { Link } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { grey } from '@mui/material/colors';
import ModalSendOfEmail from '../../../logbook/modal/ModalSendOfEmail.component';
import ModalSendOfMexal from '../../../logbook/modal/ModalSendOfMexal.component';
import { SendOfConf } from '../../../../module/logbook/conf/SendOf.conf';
import deliveryNoteModule from '../../../../module/deliveryNote';
import IconDownlaodComponent from '../../../detail/components/IconDownload.component';
import { API } from '../../../../module/deliveryNote/api';
import _ from 'lodash';
import RectangleChip from '../../../common/RectangleChip.component';

const TableRowLogbook = ({
  color,
  id,
  open,
  onChangeExpanded = () => {},
  deliveryNote,
  items = [],
  operationListData,
  logbook,
  setSuccessUpdate = () => {},
  code,
  supplierRowIndex,
}) => {
  const status_logbook = _.get(logbook, 'attributes.status_logbook');
  const supplier = _.get(logbook, 'attributes.id_supplier.data');
  const mexal_code = _.get(supplier, 'attributes.mexal_code');
  const nameSupplier = _.get(supplier, 'attributes.company_name');
  const of_sended = _.get(logbook, 'attributes.of_sended', false);
  const of_number = _.get(logbook, 'attributes.of_number', 0);

  return (
    <>
      <TableRow
        sx={{
          '&:last-child td, &:last-child th': { border: 0 },
          backgroundColor: open && grey[100],
        }}
        id={`row-${id}`}
      >
        <TableCell component='th' scope='row'>
          <IconButton size='small' onClick={onChangeExpanded}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{`${mexal_code} - ${nameSupplier}`}</TableCell>

        <TableCell component='th' scope='row'>
          {status_logbook && (
            <RectangleChip
              value={status_logbook}
              color={color?.color}
              backgroundColor={color?.backgroundColor}
            />
          )}
        </TableCell>

        <TableCell component='th' scope='row'>
          <Tooltip title='Logbook'>
            <Link to={`/logbook/${id}`}>
              <IconButton color='primary'>
                <LibraryBooksIcon />
              </IconButton>
            </Link>
          </Tooltip>
        </TableCell>
        <TableCell>
          <IconDownlaodComponent
            value={deliveryNote}
            module={{
              ...deliveryNoteModule,
              query: {
                PDF: { settings: API.supplierOrder },
              },
            }}
            title={`Download PDF OF`}
            hasBody={{ id_logbook: id, department: code }}
            disabled={_.isEmpty(deliveryNote)}
          />
        </TableCell>
        <TableCell>
          <ModalSendOfMexal
            id={id}
            code={code}
            deliveryNote={deliveryNote}
            items={items}
            supplier={supplier}
            operationListData={operationListData}
            setSuccessUpdate={setSuccessUpdate}
            supplierRowIndex={supplierRowIndex}
            ofSended={of_sended}
            ofNumber={of_number}
          />
        </TableCell>
        <TableCell>
          <ModalSendOfEmail
            conf={SendOfConf}
            id={id}
            data={supplier}
            disabled={_.isEmpty(deliveryNote)}
            logbook={logbook}
            setSuccessUpdate={setSuccessUpdate}
            code={{ department: code }}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default TableRowLogbook;
